import { useTranslation } from 'react-i18next';
import { formatWithThousandSeparator } from '@/utils';

interface PaymentStatusProps {
  headerTitle: string;
  titleFirst: string;
  valueFirst: number;
  titleSecond?: string;
  valueSecond?: number;
  total?: number;
  hideShipment?: boolean;
  isRTO?: boolean;
}

const PaymentStatus = ({
  headerTitle,
  titleFirst,
  titleSecond,
  total,
  valueFirst,
  valueSecond,
  hideShipment = false,
  isRTO = false,
}: PaymentStatusProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <span className='text-[11px] font-bold uppercase tracking-widest text-[rgb(115,123,140)] block mb-4'>
        {headerTitle}
      </span>

      <div className='divide-y divide-[rgb(232,230,227)]'>
        {/* First row */}
        <div className='flex items-center justify-between py-2.5'>
          <span className='text-sm text-[rgb(115,123,140)]'>{titleFirst}</span>
          <span className='text-sm font-medium text-[rgb(57,57,60)]'>
            {formatWithThousandSeparator(valueFirst)} <span className='text-[rgb(115,123,140)] uppercase'>{t('iqd')}</span>
          </span>
        </div>

        {/* Second row (shipment fee) */}
        {!isRTO && titleSecond && !hideShipment && (
          <div className='flex items-center justify-between py-2.5'>
            <span className='text-sm text-[rgb(115,123,140)]'>{titleSecond}</span>
            <span className='text-sm font-medium text-[rgb(57,57,60)]'>
              {formatWithThousandSeparator(valueSecond ?? 0)} <span className='text-[rgb(115,123,140)] uppercase'>{t('iqd')}</span>
            </span>
          </div>
        )}

        {/* Total row */}
        {!isRTO && total !== undefined && total > 0 && (
          <div className='flex items-center justify-between py-2.5'>
            <span className='text-sm font-bold text-[rgb(57,57,60)]'>{t('total')}</span>
            <span className='text-sm font-bold text-[rgb(57,57,60)]'>
              {formatWithThousandSeparator(total)} <span className='text-[rgb(115,123,140)] uppercase'>{t('iqd')}</span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentStatus;
